import { red } from '@ant-design/colors';

export default {
  apiDomain: 'api.targetron.cloud',
  homeUrl: 'targetron.com',
  company: 'Targetron',
  id: 'targetron',
  theme: {
    colorPrimary: red[5],
  },
  contactUsUrl: 'https://targetron.com/contact-us/',
  servicesUrl: 'https://targetron.com/services/',
  pricingUrl: 'https://targetron.com/pricing/',
  faqUrl: 'https://targetron.com/faq/',
  tutorialsUrl: null,
  videosUrl: null,
  communityUrl: 'https://www.facebook.com/targetron/',
  scheduleCallUrl: 'https://calendly.com/targetron',
  whatsappNumber: '639672066300',
  termsOfServiceUrl: 'https://targetron.com/terms-of-service/',
  googleMapsCategoriesUrl: null,
  stripeApiKeys: {},
  payPalClientId: 'AX72N4ZdEcc8Cx2F_9gb-CM8Lq7Y2H8eu5qtT5dwIXrmG1_PjCPU5u5dDrX4fUnLYqGmchtv96MH3LX-',
  nmiApiKeys: {
    checkout: 'checkout_public_MK58e3w3N9bnSWX39Y34bafneA56HP72',
    tokenization: 'K7n7e2-4329C6-JB2GS4-YnszDx',
  },
  availablePaymentProviders: {
    nmi: true,
    paypal: true,
    bank: true,
    crypto: true
  },
  gaToken: 'G-29YWL5HJ0E',
  googleClientId: '740632437967-39ev1ab686aqudl73mqvsiinadclla2m.apps.googleusercontent.com',
  linkedinClientId: '77foukh11ppmj6',
  hubspotClientId: null,
  pipedriveClientId: null,
  zohoClientId: null,
  includedServices: [
    'businesses',
    'google_maps_service', 'google_search_service',
    'google_maps_reviews_service', 'google_maps_reviews_monitoring',
    'leads_n_contacts', 'domains_service', 'emails_validator_service',
    'whitepages_phones', 'phones_enricher_service',
    'company_insights_service', 'ai_chain_info', 'similarweb', 'builtwith',
  ],
  headerMenuRoutes: [
    '/businesses',
    '/businesses/export/history',
    '/services',
    '/tasks'
  ],
  learnMoreLinks: {},
  videoTutorialLinks: {},
  tutorialsLinks:{},
  otherLinks:{},
  integrationsLinks: {},
};
